import React from 'react';
import Banner from './Banner'

import partimg from '../Images/Logos_part_transp.png'
import deco2 from '../Images/deco2_transp.png'
import deco3 from '../Images/deco3_transp.png'
import rhdimg from '../Images/rhd_map.jpg'

function About() {
  return (
    <React.Fragment>
      <div className="container-fluid">
      <div className="row bannerrow">
        <div className="col align-self-center"> 
          <Banner/>
        </div>
     
      </div>
        <div className="row contentrow">
          <div className="col-md-4 leftpanelother col-sm-12 col-12 mb-3 mb-sm-3 mb-md-0">
            <div className="pagetitle">
              À propos
            </div>
          </div>
          <div className="col-md-8 rightpanelother col-sm-12 col-12">
            <div className="row mt-5 mb-5" >
              <div className="col text-center">
                <img  id="img1" src={rhdimg}  alt=""/>
              </div>
            </div>
            <div className="row justify-content-center mt-3 mb-1" id="cont_row">
              <div  className="col-md-10 col-12 col-sm-12 ">
                <div  className="content_text ">
                  <div  className="content_title mb-3"> <b>Découvrir et s’informer sur la biodiversité du quartier des Rives de la Haute-Deûle.</b> </div>  
                  Biodimètre est un dispositif destiné à mesurer et analyser l’évolution de la biodiversité du quartier des Rives de la Haute-Deûle. Le dispositif se compose de capteurs et sondes, essaimés dans l’eau et dans l’air, associé à une application mobile destinée aux habitants pour le partage et la collecte d’observations de la faune et de la flore.
                  <div className="row mt-5 mb-5" id="logo_row">
                    <div  className="col text-center">
                      <img  id="img2" src={deco3}  alt=""/>
                    </div>
                  </div>
                  <div  className="content_title mb-3"><b>Devenez citoyens-collecteurs</b></div>  
                  Les données que vous collectez depuis l’application et les données des capteurs alimenteront les travaux des équipes de recherche Inria, institut national de recherche dédié aux sciences et technologies du numérique. Vous contribuez ainsi à participer, au cours des saisons, aux mesures de la biodiversité et à la mise en place d’actions pour la préserver !
                  <div className="row mt-5 mb-5" id="logo_row">
                    <div  className="col text-center">
                      <img  id="img3" src={deco2}  alt=""/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row mb-5" >
              <div  className="col text-center">
                <img  id="img4" src={partimg}  alt=""/>
              </div>
            </div>  
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default About;
